import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './BuyBookPage.css';
import config from '../functions/config';

function BuyBookPage() {
  const [book, setBook] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userName, setUserName] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [status, setStatus] = useState('Pending');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { bookId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch book details
    axios.get(`${config.BASE_URL}/api/books/${bookId}/`)
      .then(response => {
        setBook(response.data);
        setTotalPrice((response.data.price * quantity).toFixed(2));  // Set initial total price
        setLoading(false);
      })
      .catch(error => {
        setError('Error fetching book details');
        setLoading(false);
      });

    // Get user details from session
    const sessionId = Cookies.get('sessionid');
    if (sessionId) {
      getUserDetails(sessionId);
    }
  }, [bookId, quantity]);

  const getUserDetails = async (sessionId) => {
    try {
      const response = await fetch("http://127.0.0.1:8000/api/details/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Session-ID": sessionId,
        },
        credentials: "include",
      });

      if (response.ok) {
        const userData = await response.json();
        setUserName(userData.username);
      } else {
        const errorData = await response.json();
        setError(errorData.error || "Error fetching user details.");
      }
    } catch {
      setError("Failed to fetch user details.");
    }
  };

  const handleBuy = () => {
    if (quantity > book.stock) {
      alert('Quantity exceeds available stock');
      return;
    }

    const purchaseData = {
      book: book.id,
      quantity: quantity,
      address: address,
      phone_number: phoneNumber,
      total_price: totalPrice,
      status: status,
      user_name: Cookies.get('sessionid'),
    };

    axios.post('${config.BASE_URL}/api/purchase/', purchaseData)
      .then(response => {
        alert(`You bought "${book.title}"!`);
        navigate('/success');
      })
      .catch(error => {
        alert('Error processing purchase');
      });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!book) return <div>Book not found</div>;

  return (
    <div className="pt-5">
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">Library Management</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
          <li className="nav-item">
                <a className="nav-link" href="/success">
                   Books
                </a>
              </li>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a className="nav-link" href="/userhome">Home</a></li>
              <li className="nav-item"><a className="nav-link" href="/profile">Profile</a></li>
              <li className="nav-item">
            <a className="nav-link" href="/rentalhistory">Rented Books</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/purchasehistory">Purchase History</a>
          </li>             
           <li className="nav-item"><a href="/login" className="btn btn-danger">Logout</a></li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="buy-book-page container pt-5 mt-5">
        <h2>{book.title}</h2>
        <p><strong>Author:</strong> {book.author}</p>
        <p><strong>Publisher:</strong> {book.publisher}</p>
        <p><strong>Price (per copy):</strong> ${book.price}</p>

  {/* Quantity Selection */}
<div className="mb-3 mt-5">
  <label className="form-label">Quantity (Max: {book.stock}):</label>
  <div className="d-flex align-items-center">
    <button
      className="btn btn-outline-primary"
      onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
      style={{
        flex: "1 1 0", // Allow button to grow and shrink equally, starting from 0 basis
        height: "48px",
        fontSize: "1.5rem",
      }}
    >
      -
    </button>
    <input
      type="number"
      className="form-control text-center"
      value={quantity}
      min="1"
      max={book.stock}
      onChange={(e) => setQuantity(e.target.value)}
      style={{
        flex: "1 1 0", // Allow input to grow and shrink equally, starting from 0 basis
        height: "48px",
        fontSize: "1.5rem",
      }}
    />
    <button
      className="btn btn-outline-primary"
      onClick={() => setQuantity(prev => Math.min(book.stock, prev + 1))}
      style={{
        flex: "1 1 0", // Allow button to grow and shrink equally, starting from 0 basis
        height: "48px",
        fontSize: "1.5rem",
      }}
    >
      +
    </button>
  </div>
</div>



        

        {/* Address Input */}
        <div className="mb-3">
          <label>Address:</label>
          <textarea
            className="form-control"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Enter your shipping address"
            required
          />
        </div>

        {/* Phone Number Input */}
        <div className="mb-3">
          <label>Phone Number:</label>
          <input
            type="text"
            className="form-control"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Enter your phone number"
          />
        </div>

        {/* Total Price */}
        <div className="mb-3">
          <label>Total Price:</label>
          <input
            type="text"
            className="form-control"
            value={totalPrice}
            readOnly
          />
        </div>

        {/* Status */}
        <div className="mb-3">
          <label>Status:</label>
          <input
            type="text"
            className="form-control"
            value={status}
            readOnly
          />
        </div>

        <button className="btn btn-primary" onClick={handleBuy}>Buy</button>
      </div>
    </div>
  );
}

export default BuyBookPage;
